import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import MasterDetails from './masterDetails';
import UnitDetails from './unitDetails';
import ImagesList from './images';
import SalesDetails from './salesDetails';
import BuyerSummery from './buyerSummery';
import moment from 'moment/moment';
import LeaseDetails from './leaseDetails';
import UnitFeature from './unitFeatures';
import Advertisement from './advertisement';
import UnitSummary, { buildUnitSummaryPayload } from './unitSummary';
import Payable from './payable';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { endPoint } from '../../EndPoints/endPoint';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null, // for new file (File object)
  fileName: '',
  filePath: '',
  remarks: '',
  isNew: true, // ✅ identify new file
  fullUrl: '', // ✅ for existing file preview
});
const CreateUnitMaster = ({ onClose }) => {
  const { t } = useTranslation();
  const apiService = new LeaseApiService();
  const userName = useSelector(getName);
  const [activeFY, setActiveFY] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setloader] = useState(false);
  // Master Listings
  const [measurementList, setMeasurementList] = useState([]);
  const [salersList, setSalesPersonList] = useState([]);
  const [bedRoomList, setBedRoomList] = useState([]);
  const [landlordList, setLandlordList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [communityList, setcommunityList] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);
  const [unitViewList, setunitViewList] = useState([]);
  const [imageView, setImageView] = useState([]);
  const [unitCategoryList, setunitCategoryList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [countriesList, setCountries] = useState([]);
  const [cityList, setCityList] = useState([]);
  // Unit Listings
  const [manDateList, setManDateList] = useState([]);
  const [reserveAccList, setReserveAccList] = useState([]);
  const [keyStatusList, setKeyStatusList] = useState([]);
  const [unitCostList, setUnitCostList] = useState([]);
  const [paymentPlan, setPaymentPlan] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [costAccount, setCostAccount] = useState([]);
  const [agent, setAgent] = useState([]);
  const [furnishing, setFurnishing] = useState([]);
  const [refferedBy, setRefferedBy] = useState([]);
  const [enteredBy, setEnteredBy] = useState([]);
  const [furniturePlan, setFurniturePlan] = useState([]);
  const [period, setPeriod] = useState([]);
  const [sizeType, setSizeType] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [currencyList, setCurrency] = useState([]);
  const [featuresList, setFeaturesList] = useState([]);
  const [summaryList, setSummaryList] = useState([]);
  const [attachments, setAttachments] = useState([createEmptyRow()]);

  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
  const formatDate = (date) => {
    return moment(date).format('DD-MMM-YYYY');
  };

  const validationRules = [
    { key: 'property', message: t('unitMaster.validationMessages.selectProperty') },
    { key: 'unitNo', message: t('unitMaster.validationMessages.enterUnitNo') },
    { key: 'unitClass', message: t('unitMaster.validationMessages.enterUnitClass') },
    { key: 'unitType', message: t('unitMaster.validationMessages.enterUnitType') },
    { key: 'unitCategory', message: t('unitMaster.validationMessages.enterUnitCategory') },
    { key: 'unitView', message: t('unitMaster.validationMessages.enterUnitView') },
    { key: 'bedRooms', message: t('unitMaster.validationMessages.enterBedRoom') },
    { key: 'totalArea', message: t('unitMaster.validationMessages.enterTotalArea') },
  ];
  const [transectionData, setTransectionData] = useState({
    saller: null,
    landlordId: null,
    property: null,
    community: null,
    unitType: null,
    unitCategory: null,
    country: null,
    city: null,
    unitView: null,
    floor: null,
    bedRooms: null,
    unitNo: '',
    contactPerson: '',
    municipltyNo: '',
    refNo: '',
    unitClass: 'Sale',
    sector: '',
    block: '',
    bathRoom: '',
    balcony: '',
    livingarea: '',
    terraceArea: '',
    totalArea: '',
    parking: '',
    unitRate: '',
    remarks: '',
    parkingPrice: '',
    resale: false,
  });
  const [unitDetails, setUnitDetails] = useState({
    mandate: null,
    reservedAccCode: null,
    statusKey: null,
    unitCost: null,
    paymentPlan: null,
    status: null,
    costAccount: null,
    agent: null,
    furnishing: null,
    refferedBy: null,
    enteredBy: null,
    furniturePlan: null,
    unitModel: '',
    serviceCharge: '',
    unitStyle: '',
    reservedFund: '',
    storeRoom: '',
    plotNO: '',
    company: '',
    financeOffered: '',
    rentAmount: '',
    plotSize: '',
    additionalWorkCost: '',
    streetNo: '',
    opt2Cost: '',
    opt3Cost: '',
    furnitureCost: '',
    occupied: false,
    propertyRegistered: false,
    mortgaged: false,
    leased: false,
    completionDate: formattedDate,
    expiryDate: formattedDate,
    reffferedDate: formattedDate,
    enteredDate: formattedDate,
    modifiedDate: formattedDate,
  });
  const [salesDetails, setSalesDetails] = useState({
    currency: null,
    orignalPrice: '',
    orignalRateSqft: '',
    profit: '',
    profitCalculate: '',
    listingPrice: '',
    listingPriceRate: '',
    priceinothercontry: '',
    mainSalePrice: '',
    marketAnalysis: '',
    to: '',
    commPaid: '',
    commPaidCalculate: '',
    commSeller: '',
    commSellerCalculate: '',
    sellerTransferFee: '',
    sellerTransferFeeCalcu: '',
    buyerTransferFee: '',
    buyerTransferFeeCalcu: '',
    legalFee: '',
    legalFeeCalcu: '',
    miscFee: '',
    miscFeeCalcu: '',
    comment: '',
    sellerPaidDev: '',
    sellerPaidDevCalcu: '',
  });
  const [buyerSummery, setBuyerSummery] = useState({
    sellerTransfer: '',
    developerBalance: '',
    developerBalancePerc: '',
    BuyerCommission: '',
    BuyerCommissionPerc: '',
    DlDTransfer: '',
    DlDTransferPerc: '',
    administrationFee: '',
    administrationFeePerc: '',
    otherFee: '',
    otherFeePerc: '',
    allPrice: '',
    allPricePerc: '',
  });
  const [leaseDetails, setLeaseDetails] = useState({
    dueDate: formattedDate,
    rentPerAnum: '',
    rentByMonth: '',
    rentPerDay: '',
    securityDeposit: '',
    securityDepositPerc: '',
    tenantCommission: '',
    tenantCommissionPerc: '',
    landlordCommission: '',
    landlordCommissionPerc: '',
    maintenanceFee: '',
    rentPayable: '',
    IbanNo: '',
    secDepositPayable: '',
    commissionPayable: '',
    bankName: null,
    accountNo: '',
    fixedCharges: '',
    variableCharges: '',
    installment: '',
  });
  const [advertisement, setAdvertisement] = useState({
    publishStatus: false,
    xmlFeed: false,
    openHouse: false,
    marketingDesc: '',
    remarks1: '',
    remarks2: '',
    remarks3: '',
  });

  useEffect(() => {
    fetchDropdownData();
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
    // Created By is mandatory, but the personnel dropdown it was meant to
    // populate from (UMEnteredBy) isn't returned by either backend. Default
    // it to the logged-in user, same as modifiedBy already does elsewhere in
    // this file, so the mandatory check isn't blocked by an unavailable list.
    if (userName) {
      setUnitDetails((prev) => ({ ...prev, enteredBy: prev.enteredBy || { label: userName, value: userName } }));
    }
  }, []);
  const fetchDropdownData = async () => {
    try {
      // UNIT_RA_MULTIDROP (Lease Finance) confirmed live to return these
      // types correctly (lowercased "UM" prefix only, e.g. "umBedrooms").
      // Property/ReferredBy/EnteredBy/CostAccounts/AreaMeasurements/
      // SalesPersons/SellerNames/ReservedFundAccounts/Accounts/Furnished are
      // NOT returned by it at all (confirmed empty) - those are fetched
      // separately below from GET_UNIT_MULTIDROP (main backend) instead.
      // Switching everything to GET_UNIT_MULTIDROP (as a reference "-RA-"
      // copy of this project does) regressed UMSellers/Landlord, which that
      // backend doesn't return the same way - so this keeps both sources.
      const params = new URLSearchParams();
      params.append(
        'dropdownTypes',
        'UMBedrooms,UMFloors,UMUnitViews,UMUnitTypes,UMUnitCategories,UMImageTypes,UMKeyStatus,UMMandate,UMSizeTypes,UMPeriods',
      );
      const res = await apiService.getApiParamater('UNIT_RA_MULTIDROP', `?${params.toString()}`);
      const scndparams = new URLSearchParams();
      scndparams.append(
        'dropdownTypes',
        'UMBanks,UMPaymentPlans,UMCountries,UMCommunities,UMSellers,UMFurniturePlans,UMAgents,UMProjectStatus,UMFurnishing,UMCurrencies',
      );
      const scndRes = await apiService.getApiParamater('UNIT_RA_MULTIDROP', `?${scndparams.toString()}`);
      const missingParams = new URLSearchParams();
      missingParams.append(
        'dropdownTypes',
        'UMReferredBy,UMProperties,UMEnteredBy,UMCostAccounts,UMAreaMeasurements,UMSalesPersons,UMSellerNames,UMReservedFundAccounts,UMAccounts,UMFurnished',
      );
      const missingRes = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${missingParams.toString()}`);
      setBedRoomList(res?.data?.dropdowns?.umBedrooms);
      setCostAccount(missingRes?.data?.dropdowns?.UMCostAccounts);
      setEnteredBy(missingRes?.data?.dropdowns?.UMEnteredBy);
      setFloorList(res?.data?.dropdowns?.umFloors);
      setImageView(res?.data?.dropdowns?.umImageTypes);
      setKeyStatusList(res?.data?.dropdowns?.umKeyStatus);
      setManDateList(res?.data?.dropdowns?.umMandate);
      setPeriod(res?.data?.dropdowns?.umPeriods);
      setPropertyList(missingRes?.data?.dropdowns?.UMProperties);
      setRefferedBy(missingRes?.data?.dropdowns?.UMReferredBy);
      setSizeType(res?.data?.dropdowns?.umSizeTypes);
      setunitCategoryList(res?.data?.dropdowns?.umUnitCategories);
      setunitViewList(res?.data?.dropdowns?.umUnitViews);
      setUnitTypeList(res?.data?.dropdowns?.umUnitTypes);
      setAgent(scndRes?.data?.dropdowns?.umAgents);
      setProjectStatus(scndRes?.data?.dropdowns?.umProjectStatus);
      setcommunityList(scndRes?.data?.dropdowns?.umCommunities);
      setMeasurementList(missingRes?.data?.dropdowns?.UMAreaMeasurements);
      setUnitCostList(missingRes?.data?.dropdowns?.UMEnteredBy);
      setLandlordList(scndRes?.data?.dropdowns?.umSellers);
      setSalesPersonList(missingRes?.data?.dropdowns?.UMSalesPersons);
      setBankList(scndRes?.data?.dropdowns?.umBanks);
      setPaymentPlan(scndRes?.data?.dropdowns?.umPaymentPlans);
      setCountries(scndRes?.data?.dropdowns?.umCountries);
      setFurnishing(scndRes?.data?.dropdowns?.umFurnishing);
      setCurrency(scndRes?.data?.dropdowns?.umCurrencies);
      setFurniturePlan(scndRes?.data?.dropdowns?.umFurniturePlans);
      setReserveAccList(missingRes?.data?.dropdowns?.UMReservedFundAccounts);
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  // Mirrors the legacy rbSale/rbLease/rbPropertyManagement_CheckedChanged tab-set logic.
  // Yearly Rent is always omitted for now — its visibility depends on a system setting
  // (checkMultiYrLease / tbLease_Setting) with no API exposed to the frontend yet.
  const getTabList = () => {
    const list = [
      { key: 'unitMaster', label: t('unitMaster.tabs.unitMaster') },
      { key: 'unitDetails', label: t('unitMaster.tabs.unitDetails') },
      { key: 'unitFeatures', label: t('unitMaster.tabs.unitFeatures') },
    ];
    const unitClass = transectionData?.unitClass || 'Sale';
    if (unitClass === 'Lease') {
      list.push({ key: 'leaseDetails', label: t('unitMaster.tabs.leaseDetails') });
      if (String(transectionData?.unitType?.label || '').toUpperCase() === 'COMMERCIAL') {
        list.push({ key: 'payable', label: t('unitMaster.tabs.payable') });
      }
    } else if (unitClass === 'PM') {
      list.push({ key: 'leaseDetails', label: t('unitMaster.tabs.pmDetails') });
      list.push({ key: 'payable', label: t('unitMaster.tabs.payable') });
    } else {
      list.push({ key: 'salesDetails', label: t('unitMaster.tabs.salesDetails') });
      list.push({ key: 'buyerSummary', label: t('unitMaster.tabs.buyerSummary') });
    }
    list.push({ key: 'summary', label: t('unitMaster.tabs.summary') });
    list.push({ key: 'advertisement', label: t('unitMaster.tabs.advertisement') });
    list.push({ key: 'images', label: t('unitMaster.tabs.images') });
    return list;
  };
  const tabList = getTabList();
  // The tab set changes shape with Unit Class, so a stale index could point at a
  // different tab (or nothing) after switching — reset to the first tab instead.
  useEffect(() => {
    setActiveTab(0);
  }, [transectionData?.unitClass]);
  const handleBackClick = () => {
    if (onClose) onClose();
  };
  // "Amount due to Developer" is always the complement of "Seller has Paid to Developer".
  const amountDueDev = (parseFloat(salesDetails?.orignalPrice) || 0) - (parseFloat(salesDetails?.sellerPaidDev) || 0);
  const amountDueDevPercent = 100 - (parseFloat(salesDetails?.sellerPaidDevCalcu) || 0);
  const handleSave = async () => {
    try {
      setloader(true);
      for (const rule of validationRules) {
        if (!transectionData?.[rule.key]) {
          setloader(false);
          toast.warning(rule.message);
          return;
        }
      }
      if (!salesDetails?.listingPrice) {
        setloader(false);
        toast.warning('Please Enter Listing Price');
        return;
      } else if (!unitDetails?.enteredBy?.label) {
        setloader(false);
        toast.warning('Please Select Entered By User');
        return;
      }

      const scndparams = new URLSearchParams();
      scndparams.append('Action', 'CheckDuplicateUnit');
      scndparams.append('PropertyNo', transectionData?.property?.value?.value);
      scndparams.append('UnitNo', transectionData?.unitNo);
      const scndRes = await apiService.getApiParamater('UNIT_RA_COMMON', `?${scndparams.toString()}`);
      const duplicateCheck = scndRes?.data?.result?.data?.[''];

      if (duplicateCheck === 1) {
        toast.warning('Unit already exists for this property');
        setloader(false);
        return;
      }
      const unitFeatures = featuresList?.map((item, index) => {
        return {
          status: item?.DescType || '0',
          description: item?.Description || '0',
          value: item?.Value,
          cnt: parseFloat(item?.Cnt) || 0,
          amount: parseFloat(item?.Amount) || 0,
          isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
        };
      });
      let uploadedFiles = []
      const hasNewFiles = attachments?.some((item) => item.file instanceof File && item.isNew);
      if (hasNewFiles) {
        uploadedFiles = await handleUpload();
      }
      const unitImages = attachments?.reduce((acc, item) => {
        const uploadedFile = uploadedFiles.find(
          (file) => file.originalFileName === item.file?.name
        );

        if (uploadedFile?.fileName) {
          acc.push({
            record_Id: 0,
            image_Description: item.remarks || "0",
            image_Filename: uploadedFile.fileName,
            // Only the first image is the default/cover image - marking
            // every single one isDefault:true likely violates a "one default
            // per unit" constraint on insert, causing every image after the
            // first to silently fail while the overall save still succeeds.
            isDefault: acc.length === 0,
            folder: "0",
            url: uploadedFile.fullUrl || "0",
            // Every image here is new (this is the create flow) - matches
            // updateUnitMaster.js's convention, where isAdded distinguishes
            // new images from already-existing ones on the backend.
            isAdded: true,
            isUpdated: false,
            isDeleted: false,
          });
        }

        return acc;
      }, []);
      // TEMPORARY - to see exactly what's being sent for images, since a
      // successful unit save with the image still missing from
      // GetUnitImagesByRefNo means either it never made it into this array,
      // or it did and something downstream (backend) dropped it. Check this
      // in the browser console right after clicking Save.
      console.log('unitImages being sent to CREATE_UNIT_RA:', attachments, uploadedFiles, unitImages);
      const body = {
        unitRAMasterMain: {
          unitMaster: {
            ref_No: transectionData?.refNo || '0',
            property_No: transectionData?.property?.value?.value || '0',
            property_Name: transectionData?.property?.label || '0',
            unit_No: transectionData?.unitNo || '0',
            rerA_STR_No: transectionData?.municipltyNo || '0',
            street_No: unitDetails?.streetNo || '0',
            street_Name: leaseDetails?.IbanNo || '0',
            unit_Type: transectionData?.unitType?.label || '0',
            unit_Category: transectionData?.unitCategory?.label || '0',
            unit_Style: unitDetails?.unitStyle || '0',
            unit_Model: unitDetails?.unitModel || '0',
            unit_Zone: transectionData?.sector || '0',
            plot_No: unitDetails?.plotNO || '0',
            plot_Size: unitDetails?.plotSize || '0',
            block: transectionData?.block || '0',
            floor: transectionData?.floor?.label || '0',
            unit_View: transectionData?.unitView?.label || '0',
            completion_Date: unitDetails?.completionDate,
            unit_Class: transectionData?.unitClass || '0',
            livingRooms: transectionData?.livingarea || '0',
            bedrooms: transectionData?.bedRooms?.label || '0',
            storeRooms: unitDetails?.storeRoom || '0',
            parking: transectionData?.parking || '0',
            facilities: unitDetails?.furnishing?.label || '0',
            status: 'Available',
            payment_Plan: unitDetails?.paymentPlan?.label || '0',
            broker_Name: unitDetails?.agent?.label || '0',
            seller_Id: transectionData?.landlordId?.label || '0',
            seller_Name: transectionData?.saller?.label || '0',
            adv_Listing: Boolean(advertisement?.xmlFeed),
            adv_NewsPaper: false,
            adv_Web: false,
            adv_OpenHouse: Boolean(advertisement?.openHouse),
            adv1: false,
            adv2: false,
            adv3: false,
            adv_Remarks1: advertisement?.remarks1 || '0',
            adv_Remarks2: advertisement?.remarks2 || '0',
            adv_Remarks3: advertisement?.remarks3 || '0',
            remarks: advertisement?.marketingDesc || '0',
            internalRemarks: transectionData?.remarks || '0',
            otherSpace1: '0',
            bathrooms: transectionData?.bathRoom || '0',
            balcony: transectionData?.balcony || '0',
            terrace: transectionData?.terraceArea || '0',
            total_Area: parseFloat(transectionData?.totalArea) || 0,
            measured_Area: parseFloat(transectionData?.netArea) || 0,
            sqft_Rate: parseFloat(transectionData?.unitRate || 0),
            purchase_Value: parseFloat(unitDetails?.unitCost?.label) || 0,
            total_Value: parseFloat(salesDetails?.orignalPrice) || 0,
            measured_Value: parseFloat(salesDetails?.mainSalePrice) || 0,
            roundOff_Value: parseFloat(salesDetails?.listingPrice) || 0,
            parking_Price: parseFloat(transectionData?.parkingPrice) || 0,
            all_In_Price:
              (parseFloat(salesDetails?.profit) || 0) +
              (parseFloat(salesDetails?.sellerPaidDev) || 0) +
              amountDueDev +
              (parseFloat(salesDetails?.commPaid) || 0) +
              (parseFloat(salesDetails?.buyerTransferFee) || 0) +
              (parseFloat(salesDetails?.legalFee) || 0) +
              (parseFloat(salesDetails?.miscFee) || 0),
            premium: parseFloat(salesDetails?.profit) || 0,
            premium_Percent: parseFloat(salesDetails?.profitCalculate) || 0,
            seller_Commission: parseFloat(salesDetails?.commSeller) || 0,
            seller_Commission_Percent: parseFloat(salesDetails?.commSellerCalculate) || 0,
            buyer_Commission: parseFloat(salesDetails?.commPaid) || 0,
            buyer_Commission_Percent: parseFloat(salesDetails?.commPaidCalculate) || 0,
            seller_TransferFee: parseFloat(salesDetails?.sellerTransferFee) || 0,
            seller_TransferFee_Percent: parseFloat(salesDetails?.sellerTransferFeeCalcu) || 0,
            buyer_TransferFee: parseFloat(salesDetails?.buyerTransferFee) || 0,
            buyer_TransferFee_Percent: parseFloat(salesDetails?.buyerTransferFeeCalcu) || 0,
            admin_Fees: parseFloat(salesDetails?.legalFee) || 0,
            admin_Fees_Percent: parseFloat(salesDetails?.legalFeeCalcu) || 0,
            other_Fees: parseFloat(salesDetails?.miscFee) || 0,
            other_Fees_Percent: parseFloat(salesDetails?.miscFeeCalcu) || 0,
            other_Fees_Remarks: salesDetails?.comment || '0',
            seller_Paid: parseFloat(salesDetails?.sellerPaidDev) || 0,
            seller_Paid_Percent: parseFloat(salesDetails?.sellerPaidDevCalcu) || 0,
            developer_Due: amountDueDev,
            developer_Due_Percent: amountDueDevPercent,
            rent_Per_Annum: parseFloat(leaseDetails?.rentPerAnum) || 0,
            short_Term_Rent: parseFloat(leaseDetails?.rentByMonth) || 0,
            short_Term_Period: '0',
            rent_Per_Day: parseFloat(leaseDetails?.rentPerDay) || 0,
            security_Deposit: parseFloat(leaseDetails?.securityDeposit) || 0,
            advance_Deposit: parseFloat(unitDetails?.reservedFund) || 0,
            tenant_Commission: parseFloat(leaseDetails?.tenantCommission) || 0,
            landlord_Commission: parseFloat(leaseDetails?.landlordCommission) || 0,
            maintenance_Fee: parseFloat(leaseDetails?.maintenanceFee) || 0,
            negotiable: true,
            currency: salesDetails?.currency?.label || '0',
            cmA_Range1: parseFloat(salesDetails?.marketAnalysis) || 0,
            cmA_Range2: parseFloat(salesDetails?.to) || 0,
            installments: parseFloat(leaseDetails?.installment) || 0,
            rentPayableTo: leaseDetails?.rentPayable || '0',
            rentBankName: leaseDetails?.bankName?.label || '0',
            rentBankAcNo: leaseDetails?.accountNo || '0',
            secDepPayableTo: leaseDetails?.secDepositPayable || '0',
            comPayableTo: leaseDetails?.commissionPayable || '0',
            key_Status: unitDetails?.statusKey?.label || '0',
            publishStatus: Boolean(advertisement?.publishStatus),
            publishDate: advertisement?.publishStatus ? new Date() : new Date('1900-01-01'),
            serviceCharge: unitDetails?.serviceCharge || '0',
            ownerOccupied: Boolean(unitDetails?.occupied),
            leased: Boolean(unitDetails?.leased),
            leaseAmount: parseFloat(unitDetails?.rentAmount) || 0,
            leaseExpiry: unitDetails?.expiryDate,
            mandate: unitDetails?.mandate?.label || '0',
            financeCompany: unitDetails?.financeOffered || '0',
            mortgaged: Boolean(unitDetails?.mortgaged),
            mortgageCompany: unitDetails?.company || '0',
            propertyRegistered: Boolean(unitDetails?.propertyRegistered),
            portfolio: parseFloat(unitDetails?.furnitureCost) || 0,
            portfolioManager: unitDetails?.furniturePlan?.label || '0',
            propertyType: unitDetails?.status?.label || '0',
            factor: 0,
            common: 0,
            cp: 0,
            effeciency: leaseDetails?.dueDate,
            listingPriceUSD: parseFloat(salesDetails?.priceinothercontry) || 0,
            monthlyIncome: (parseFloat(leaseDetails?.fixedCharges) || 0).toFixed(3),
            annualIncome: (parseFloat(leaseDetails?.variableCharges) || 0).toFixed(3),
            exp9: unitDetails?.costAccount?.label || '0',
            exp10: unitDetails?.reservedAccCode?.label || '0',
            refered_By: unitDetails?.refferedBy?.label || '0',
            refered_On: unitDetails?.reffferedDate,
            createdBy: unitDetails?.enteredBy?.label || '0',
            createdOn: unitDetails?.enteredDate,
            modifiedBy: userName || '0',
            modifiedOn: today,
          },
          unitFeatures: unitFeatures,
          unitSummaries: buildUnitSummaryPayload(summaryList, { propertyNo: transectionData?.property?.value?.value, propertyName: transectionData?.property?.label, unitNo: transectionData?.unitNo, userName }),

          unitImages: unitImages,
          unitPayables: [
            {
              description: '0',
              value: true,
              landlord: true,
              tenant: true,
            },
          ],
          unitYearlyRents: [
            {
              year: 0,
              rentPerSqftRest: 0,
              rentPerSqftKitchen: 0,
              rentPerSqftTerrace: 0,
              totalRent: 0,
              scPerSqftRest: 0,
              scPerSqftKitchen: 0,
              scPerSqftTerrace: 0,
              totalServiceCharge: 0,
              chilledWaterPerSqftRest: 0,
              chilledWaterPerSqftKitchen: 0,
              chilledWaterPerSqftTerrace: 0,
              totalChilledWaterCharge: 0,
            },
          ],
          unitFixedCharges: [
            {
              description: '0',
              amount: 0,
            },
          ],
        },
      };
      const postRes = await apiService.post('CREATE_UNIT_RA', body);
      if (postRes?.data?.statusCode === 200 || postRes?.data?.statusCode === 201) {
        // if (attachments) {
        //   handleUpload(postRes?.data?.result?.ref_No);
        // }
        toast.success(postRes?.data?.message);
        setloader(false);
        if (onClose) onClose();
      } else {
        toast.warning(`${postRes?.data?.message}`);
        setloader(false);
      }
    } catch (error) {
      // Previously silent - a failed image upload or save (network error,
      // timeout, backend error) showed nothing beyond the loader stopping,
      // so a real failure looked identical to a successful save.
      console.error('Error Save Data', error);
      toast.error(error?.response?.data?.message || error?.message || 'Failed to save unit. Please try again.');
      setloader(false);
    } finally {
      setloader(false);
    }
  };
  const handleUpload = async (ref_No) => {
    const formData = new FormData();

    let token = localStorage.getItem('Token');
    let db = localStorage.getItem('DataBase');
    // const validFiles = attachments.filter(
    //     (item) => item.file instanceof File
    // );
    const validFiles = attachments.filter((item) => item.file instanceof File && item.isNew);

    validFiles.forEach(({ file }) => {
      formData.append('files', file);
    });

    // formData.append('refNo', "");
    formData.append('fileCategory', 'Images');

    // Must upload to UNIT_FILE_RA (Lease Finance), not the main backend's
    // UNIT_FILE - UnitManagementRARepository.InsertUnitImages moves the file
    // from ITS OWN server's F:\TempFiles, so it has to land there directly.
    const response = await axios.post(endPoint.UNIT_FILE_RA, formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,
      },
    });
    if (response?.data) {
      return response?.data?.result || [];
      // additionalDataUpload(response?.data?.result, ref_No);
    }
  };
  const additionalDataUpload = async (data, refNo) => {
    const unitFeatures = featuresList?.map((item, index) => {
      return {
        status: item?.DescType || '0',
        description: item?.Description || '0',
        value: item?.Value,
        cnt: parseFloat(item?.Cnt) || 0,
        amount: parseFloat(item?.Amount) || 0,
        isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
      };
    });
    const image = data?.map((item, index) => {
      return {
        record_Id: 0,
        image_Description: item?.originalFileName || '0',
        image_Filename: item?.fileName || '0',
        isDefault: true,
        folder: item?.filePath || '0',
        url: item?.fullUrl || '0',
        isAdded: true,
        isUpdated: false,
        isDeleted: false,
      };
    });
    const body = {
      refNo: refNo || '0',
      unitFeatures: unitFeatures,
      unitSummaries: buildUnitSummaryPayload(summaryList, { propertyNo: transectionData?.property?.value?.value, propertyName: transectionData?.property?.label, unitNo: transectionData?.unitNo, userName }),
      unitImages: image,
      unitPayables: [
        {
          description: '0',
          value: true,
          landlord: true,
          tenant: true,
        },
      ],
      unitYearlyRents: [
        {
          year: 0,
          rentPerSqftRest: 0,
          rentPerSqftKitchen: 0,
          rentPerSqftTerrace: 0,
          totalRent: 0,
          scPerSqftRest: 0,
          scPerSqftKitchen: 0,
          scPerSqftTerrace: 0,
          totalServiceCharge: 0,
          chilledWaterPerSqftRest: 0,
          chilledWaterPerSqftKitchen: 0,
          chilledWaterPerSqftTerrace: 0,
          totalChilledWaterCharge: 0,
        },
      ],
      unitFixedCharges: [
        {
          description: '0',
          amount: 0,
        },
      ],
    };
    const postRes = await apiService.post('POST_UNIT_ADDITIONAL', body);
  };
  return (
    <div className="d-flex flex-column unit-modal-form" style={{ height: '85vh' }}>
      <div className="p-3 border-bottom d-flex align-items-center justify-content-between flex-shrink-0">
        <h5 className="mb-0">{t('unitMaster.addFormTitle')}</h5>
        <button type="button" className="btn-close" aria-label="Close" onClick={handleBackClick}></button>
      </div>
      <div className="p-3" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4 unit-modal-tabs">
          {tabList.map((tab, index) => (
            <div
              key={tab.key}
              className={`dashitems sidebar-text center ${activeTab === index ? 'sideActive' : ''}`}
              onClick={() => handleTabClick(index)}
            >
              {tab.label}
            </div>
          ))}
        </div>
      </div>
      {tabList[activeTab]?.key === 'unitMaster' && (
        <MasterDetails
          tableLoading={tableLoading}
          countriesList={countriesList}
          salersList={salersList}
          setCityList={setCityList}
          setTransectionData={setTransectionData}
          propertyList={propertyList}
          cityList={cityList}
          setFeaturesList={setFeaturesList}
          transectionData={transectionData}
          landlordList={landlordList}
          communityList={communityList}
          unitTypeList={unitTypeList}
          unitViewList={unitViewList}
          floorList={floorList}
          unitCategoryList={unitCategoryList}
          setcommunityList={setcommunityList}
          setunitCategoryList={setunitCategoryList}
          bedRoomList={bedRoomList}
        />
      )}
      {tabList[activeTab]?.key === 'unitDetails' && (
        <UnitDetails
          tableLoading={tableLoading}
          manDateList={manDateList}
          reserveAccList={reserveAccList}
          agent={agent}
          setTransectionData={setUnitDetails}
          keyStatusList={keyStatusList}
          unitCostList={unitCostList}
          paymentPlan={paymentPlan}
          furnishing={furnishing}
          transectionData={unitDetails}
          projectStatus={projectStatus}
          costAccount={costAccount}
          refferedBy={refferedBy}
          enteredBy={enteredBy}
          furniturePlan={furniturePlan}
        />
      )}
      {tabList[activeTab]?.key === 'unitFeatures' && <UnitFeature tableLoading={tableLoading} setFeaturesList={setFeaturesList} featuresList={featuresList} />}
      {tabList[activeTab]?.key === 'salesDetails' && (
        <SalesDetails tableLoading={tableLoading} setTransectionData={setSalesDetails} transectionData={salesDetails} countriesList={countriesList} totalArea={transectionData?.totalArea} />
      )}
      {tabList[activeTab]?.key === 'buyerSummary' && <BuyerSummery tableLoading={tableLoading} salesDetails={salesDetails} />}
      {tabList[activeTab]?.key === 'leaseDetails' && (
        <LeaseDetails
          tableLoading={tableLoading}
          setTransectionData={setLeaseDetails}
          transectionData={leaseDetails}
          bankList={bankList}
          unitClass={transectionData?.unitClass}
        />
      )}
      {tabList[activeTab]?.key === 'payable' && <Payable tableLoading={tableLoading} />}
      {tabList[activeTab]?.key === 'summary' && <UnitSummary summaryList={summaryList} setSummaryList={setSummaryList} readOnly={false} />}
      {tabList[activeTab]?.key === 'advertisement' && (
        <Advertisement tableLoading={tableLoading} setTransectionData={setAdvertisement} transectionData={advertisement} />
      )}
      {tabList[activeTab]?.key === 'images' && <ImagesList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} />}
      </div>
      <div className="p-3 border-top d-flex justify-content-start gap-3 flex-shrink-0">
        {loading === true ? (
          <div className="mainbtn flex-end gap-2">
            <ClipLoader color="#ffffff" className="mt-1" size={20} />
          </div>
        ) : (
          <div className="mainbtn flex-end gap-2" onClick={handleSave}>
            <FaSave color="#fff" className="center mt-1 mx-2" />
            <div className="center">{t('common.save')}</div>
          </div>
        )}
        <div className="mainbtnRed flex-end gap-2" onClick={handleBackClick}>
          <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
          <div className="center">{t('common.cancel')}</div>
        </div>
      </div>
    </div>
  );
};
export default CreateUnitMaster;
